<template>
  <div class="container">
    <content-header :data="[{text:'红包领取', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
        <div class="search-entry">
            <el-input
              placeholder="请输入用户昵称"
              v-model="nickName">
            </el-input>
        </div>
        <div class="search-entry">
            <el-input
              placeholder="请输入手机号"
              v-model="phoneNumber">
            </el-input>
        </div>
        <div class="search-entry">
            <el-input
              placeholder="请输入二维码"
              v-model="qrcodeNumber">
            </el-input>
        </div>
        <div class="search-entry">
            <el-input
              placeholder="请输入门店名称"
              v-model="shopName">
            </el-input>
        </div>
        <div class="search-entry">
          <el-select v-model="provinceId" clearable value-key="id" placeholder="请选择省/直辖市" @change="provinceChange">
            <el-option
              v-for="item in provinceIds"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="search-entry">
          <el-select v-model="cityId" clearable value-key="id" placeholder="请选择市" @change="cityChange">
            <el-option
              v-for="item in cityIds"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="search-entry">
          <el-select v-model="districtId" clearable value-key="id" placeholder="请选择区/县" @change="searchHandle">
            <el-option
              v-for="item in districtIds"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="search-entry">
          <el-select v-model="status" clearable value-key="id" placeholder="请选择状态" @change="searchHandle">
            <el-option
              v-for="item in statusIds"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="search-entry">
          <span>领取时间</span>
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="dateChange"
            :picker-options="datePickerOptions">
          </el-date-picker>
        </div>
        <div class="search-btn">
          <el-button type="primary" @click="searchHandle">查询</el-button>
          <el-button type="primary" @click="exportHandle" v-permission="['redenvelope.open.export']">导出</el-button>
          <el-button type="primary" @click="clearHandle" v-permission="['redenvelope.open.export']">清理失败记录</el-button>
        </div>
      </div>
      <!-- 列表区域 -->
      <div class="content-list">
        <el-table
          :data="tableData"
          border
          stripe>
          <el-table-column
            prop="nickName"
            label="用户"
            width="80"
            fixed>
          </el-table-column>
          <el-table-column
            prop="shopName"
            label="门店"
            width="260">
          </el-table-column>
          <el-table-column
            label="地区"
            width="180">
            <template slot-scope="scope">
            {{scope.row.provinceName+"/"+scope.row.cityName+"/"+scope.row.districtName}}
            </template>
          </el-table-column>
          <el-table-column
            prop="phoneNumber"
            label="手机号"
            width="120">
          </el-table-column>
          <el-table-column
            prop="name"
            label="红包"
            width="200">
          </el-table-column>
          <el-table-column
            prop="brand"
            label="品牌名称">
          </el-table-column>
          <el-table-column
            prop="product"
            label="商品编号">
          </el-table-column>
          <el-table-column
            prop="qrcodeNumber"
            label="二维码编号"
            width="160">
          </el-table-column>
          <el-table-column
            prop="money"
            label="金额">
          </el-table-column>
          <el-table-column
            label="状态">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.message" placement="bottom">
                <span>{{scope.row.status==1?'成功':(scope.row.status==2?'失败':'重发成功')}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="openTime"
            label="领取时间"
            width="180">
          </el-table-column>
          <!--el-table-column
            fixed="right"
            label="操作"
            width="200">
            <template slot-scope="scope">
              <el-button @click="editHandle(scope)" type="text" size="small" >修改</el-button>
              <el-button @click="deleteHandle(scope)" type="text" size="small" >删除</el-button>
            </template>
          </el-table-column-->
        </el-table>
        <div class="pagination" v-if="total > pageSize">
          <el-pagination
            @size-change="pageSizeChange"
            @current-change="curPageChange"
            :current-page="curPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import constants from 'config/constants'
  import RedEnvelopeModel from 'models/redenvelope'
  import ShopModel from 'models/shop'
  import permission from 'directive/permission/index.js'

  export default {
    directives: { permission },
    data () {
      return {
        domainPic: constants.basic.domain_pic,
        nickName: '',
        phoneNumber: '',
        qrcodeNumber: '',
        shopName: '',
        provinceId: '',
        cityId: '',
        districtId: '',
        provinceIds: [],
        cityIds: [],
        districtIds: [],
        tableData: [],
        isObjShow: false,
        curObj: {
          id: '',
          name: '',
          image: '',
        },
        formLabelWidth: '80px',
        curObjRules: {
          name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
        },
        curPage: 1,
        pageSize: 10,
        total: 0,
        //
        uploadForm: {key: '', token: ''},
        qiniuHost: '',
        //
        status: '',
        statusIds: [{id: '1', name: '发红包成功'}, {id: '2', name: '发红包失败'}],
        startDate: '',
        endDate: '',
        dateRange: '',
        datePickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
      }
    },
    created () {
      this.getObjList()
      this.provinceId = 510000
      ShopModel.findArea({parentId: 0}).then(res => {
        this.provinceIds = res
      })
      ShopModel.findArea({parentId: 510000}).then(res => {
        this.cityIds = res
      })
    },
    methods: {
      pageSizeChange (size) {
        this.pageSize = size
        this.getObjList()
      },
      curPageChange (page) {
        this.curPage = page
        this.getObjList()
      },
      getObjList (opts) {
        const _opts = {
          curPage: this.curPage,
          pageSize: this.pageSize,
          nickName: this.nickName,
          phoneNumber: this.phoneNumber,
          qrcodeNumber: this.qrcodeNumber,
          shopName: this.shopName,
          provinceId: this.provinceId,
          cityId: this.cityId,
          districtId: this.districtId,
          status: this.status,
          startDate: this.startDate,
          endDate: this.endDate
        }
        // 合并参数
        if (typeof opts === 'object') Object.assign(_opts, opts)
        //
        RedEnvelopeModel.findOpen(_opts).then(res => {
          this.tableData = res.rows
          this.total = res.total
        })
      },
      searchHandle () {
        this.getObjList()
      },
      dateChange (value) {
        if (value) {
          this.startDate = value[0]
          this.endDate = value[1]
        } else {
          this.startDate = ''
          this.endDate = ''
        }
      },
      provinceChange (value) {
        ShopModel.findArea({parentId: value}).then(res => {
          this.cityIds = res
        })
      },
      cityChange (value) {
        ShopModel.findArea({parentId: value}).then(res => {
          this.districtIds = res
        })
      },
      exportHandle () {
        const _opts = {
          nickName: this.nickName,
          phoneNumber: this.phoneNumber,
          qrcodeNumber: this.qrcodeNumber,
          shopName: this.shopName,
          provinceId: this.provinceId,
          cityId: this.cityId,
          districtId: this.districtId,
          status: this.status,
          startDate: this.startDate,
          endDate: this.endDate
        }
        RedEnvelopeModel.exportOpen(_opts)
      },
      //
      clearHandle (item) {
        this.$confirm('是否清除领取失败记录？清除后可以重新扫码领取')
          .then(_ => {
            RedEnvelopeModel.clearFailed().then(() => {
              this.$message({ message: '清理成功', type: 'success' })
            }).catch(err => {
              this.$message({ message: err.message, type: 'error' })
            })
          })
          .catch(_ => {})
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
      .search-entry
        display: inline-block
        vertical-align: top
        margin-right: 10px
        margin-bottom: 10px
      .search-btn
        display: inline-block
        vertical-align: top
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
      .pagination
        margin-top: 10px
    .new-wrap
      .el-input
        width: 300px
      .form-title
        padding-top: 10px
        padding-bottom: 10px
        font-size: 12px
        color: #aaa
      .check-title
        text-align: right
        display: inline-block
        vertical-align: middle
        width: 90px
        font-size: 14px
        color: #48576a
        line-height: 1
        padding: 11px 12px 11px 0
        box-sizing: border-box
      .avatar-uploader
          border: 1px dashed #d9d9d9
          border-radius: 6px
          cursor: pointer
          position: relative
          overflow: hidden
          width: 180px
          &:hover
            border-color: #409EFF
          .avatar-uploader-icon
            font-size: 28px
            color: #8c939d
            width: 178px
            height: 178px
            line-height: 178px
            text-align: center
          .avatar
            width: 178px
            height: 178px
            display: block
</style>



// WEBPACK FOOTER //
// src/views/RedEnvelopeOpen.vue